import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faLock } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from './AuthContext';
import { oktaConfig } from './AuthConfig';

function AuthBlock() {
  const navigate = useNavigate();
  const { oktaAuth } = useOktaAuth();
  const { user, isAuthenticated, isLoading, logout: contextLogout } = useAuth();

  const logout = async () => {
    contextLogout();
    oktaAuth.signOut({
      postLogoutRedirectUri: oktaConfig.postLogoutRedirectUri,
    });
  };

  if (isLoading) {
    return (
      <div className="user-grp">
        <div className="user-wrapper">
          <FontAwesomeIcon icon={faSpinner} />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="user-grp">
        <div className="user-wrapper">
          <span>
            <FontAwesomeIcon icon={faLock} onClick={() => navigate('/auth')} />
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="user-grp">
      <div className="user-wrapper">
        <img src="/toolkit/images/profile.svg" alt="" className="profile-icon" />
        <div className="user">
          <span className="user-name">{user?.name}</span>
          <img src="/toolkit/images/chevron-down-rounded.svg" className="dropdown-arrow" alt="" />
        </div>
      </div>

      <div className="dropdown-nav contracted">
        <Link to="/" onClick={logout} className="logout">
          Log out
        </Link>
      </div>
    </div>
  );
}

export default AuthBlock;
